import PagedElements from '@/models/paged/pagedelements'
import MailTemplateListViewModel from '../view/mailtemplatelistviewmodel'

export default class PagedMailTemplates extends PagedElements<MailTemplateListViewModel> {
  constructor(init?: Partial<PagedMailTemplates>) {
    super(init)
  }
}
